import { pixels_to_km } from "./constants"

export function convertToGrid(x:number, y:number){
    const grid_x = (x - 20) / 40
    const grid_y = (y - 20) / 40

    //split into 9 boxes within the box
    // top left, top, top right
    // left, middle, right
    // bottom left, bottom, bottom right

    let words = ""
    
    if (grid_y % 1 < 0.3){
        words += "north"
    }else if (grid_y % 1 > 0.7){
        words += "south"
    }
    if (grid_x % 1 < 0.3){
        words += "west"
    }else if (grid_x % 1 > 0.7){
        words += "east"
    }

    if (words.length == 0){
        words = "middle"
    }

    const letter = String.fromCharCode(64+Math.ceil(grid_y))
    const number = Math.ceil(grid_x)

    return words + " of " + letter + number.toFixed(0)
}

export function direction(x:number, y:number){
    //convert a vector into a verbal direction, mixing north/east/south/west

    //normalise
    const dist = Math.sqrt(x ** 2 + y ** 2)
    const x_n = x / dist;
    const y_n = y / dist;

    var words = ""

    if (y_n < -0.3){
        words += "north"
    }else if (y_n > 0.3){
        words += "south"
    }
    if (x_n % 1 < -0.3){
        words += "west"
    }else if (x_n > 0.3){
        words += "east"
    }

    return words;
}